import Base from "@/controllers/base";
export default class MapMarker extends Base {
  constructor(elem) {
    super(elem);
    this.initMarker();
  }

  initMarker() {
    if (this.elem.dataset.id == "depot-map") {
      this.initDepotMarker();
    }
    if (this.elem.dataset.id == "driver-track") {
      this.initDriverTrackMarker();
    }
  }

  initDepotMarker() {
    window.buildMarker = (location, callback) => {
      var li = document.querySelector(`#c-${location.id}`);
      if (li) {
        li.addEventListener("click", callback);
      }
    };
    window.activeMarker = (location) => {
      NApp.removeClass("ul.trigger-marker li", "active");
      NApp.addClass(`#c-${location.id}`, "active");
    };
  }

  initDriverTrackMarker() {
    window.buildMarker = (location, callback) => {
      var li = document.querySelector(`#trucker-${location.company_id}`);
      if (li) {
        li.querySelector(".time").innerHTML = location.time;
        li.addEventListener("click", callback);
      }
    };
    window.activeMarker = (location) => {
      NApp.removeClass("ul.trigger-marker li", "active");
      NApp.addClass(`#trucker-${location.company_id}`, "active");
      var current = document.querySelector(`#trucker-${location.company_id}`);
      if (current) current.scrollIntoView();
    };
  }
}
